module.exports = __webpack_public_path__ + "media/images/undraw/reserve/feedback-17d4cf4b4d775c03630821947b0290e7.png";